goog.provide("shadow.js.shim.module$$mui$material$FormHelperText$default");
shadow.js.shim.module$$mui$material$FormHelperText$default = shadow.js.shim.module$$mui$material$FormHelperText.default;
